<div class="traffic-layer-widget">
    <span class="live-traffic-section live-traffic">
        Live traffic
    </span>
    <span class="live-traffic-legends live-traffic-section">
        <span>Fast</span>
        <div class="live-traffic-legends-image"></div>
        <span>Slow</span>
    </span>
</div>